import { mapUrlToPageLogProps, Page } from 'components/Logs'
import Main from './TaxesMain'

export default {
  Main,
  Logs: mapUrlToPageLogProps(({ params }) => ({
    title: 'Imposto',
    entity: 'tax',
    entityId: params.taxId,
  }))(Page),
  LogsTaxType: mapUrlToPageLogProps(({ params }) => ({
    title: 'Tipo de imposto',
    entity: 'tax_type',
    entityId: params.taxTypeId,
  }))(Page),
}
